import React from 'react'
import { useEventListeners } from '@morningtrain/react-helpers'

export const HandleOuterClicksContext = React.createContext()

export default function HandleOuterClicks (props) {
  const [trigger, onClick, removeOnClick] = useEventListeners()

  return (
    <HandleOuterClicksContext.Provider value={{ onClick, removeOnClick }}>
      {React.Children.map(props.children, child => (
        React.cloneElement(child, {
          onClick: (e) => {
            e.persist()
            trigger(e)
          }
        })
      ))}
    </HandleOuterClicksContext.Provider>
  )
}
